/* This file is autogenerated, see readme.md for instructions */
import NumberSvgIcon from '@bloomreach/banana-theme/icons/number.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const NumberIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <NumberSvgIcon />
    </Icon>
  );
});

NumberIcon.displayName = 'NumberIcon';

export default NumberIcon;
